import { useTranslation } from "react-i18next";
import AiGeneratingStatus from "./AiGeneratingStatus";

const AiFeedback = ({
  isLoading = false,
  errorMessage = "",
  loadingKey,
  errorKey,
}) => {
  const { t } = useTranslation();

  if (isLoading && loadingKey) {
    return <AiGeneratingStatus message={t(loadingKey)} />;
  }

  if (!isLoading && errorMessage && errorKey) {
    return (
      <p className="reading-assistant-inline-error" role="alert">
        {t(errorKey, { message: errorMessage })}
      </p>
    );
  }

  return null;
};

export default AiFeedback;
